import Vivus from 'vivus'
import $ from 'jquery'
import ScrollMagic from 'scrollmagic'
import _ from 'lodash'

export default function () {
  // activete whaen in viewport
  const controller = new ScrollMagic.Controller()
  _.times(3, i => {
    new ScrollMagic.Scene({
      triggerElement: '#demo',
      reverse: false
    })
    .setClassToggle(`.pic${i + 1}`, 'visible')
    .addTo(controller)
  })

  let count = 0
  // cache dom
  const $megabutton = $('.demo__megabutton')
  const $megatext = $('.demo__megatext')
  const $overlay = $('.demo__overlay')
  const $pain = $('.demo__pain')
  const $button = $('.demo__button')

  $button.on('click', function (e) {
    e.preventDefault()
    const $this = $(this)
    count++
    $this.off().addClass('fade-out').attr('disabled', 'disabled')
    $this.parent().addClass('color')
    $this.next().off().css({ cursor: 'default' })
    if (count === 3) {
      $megabutton.addClass('visible')
      $megatext.addClass('visible')
    }
  })

  $pain.on('click', function (e) {
    e.preventDefault()
    const $this = $(this)
    count++
    $this.off().css({ cursor: 'default' })
    $this.prev().off().addClass('fade-out').attr('disabled', 'disabled')
    $this.parent().addClass('color')
    if (count === 3) {
      $megabutton.addClass('visible')
      $megatext.addClass('visible')
    }
  })

  $megabutton.on('click', function () {
    const $this = $(this)
    const formula = new Vivus('svg-formula', {
      type: 'scenario',
      start: 'manual'
    })
    $('#svg-formula').addClass('visible')
    formula.play(1, switchScene)

    $this.removeClass('visible')
    $overlay.addClass('fade-out')
    $megatext.removeClass('visible')

    function switchScene () {
      setTimeout(function () {
        $pain.addClass('cured')
      }, 500)

      setTimeout(function () {
        $pain.addClass('fade-out')
      }, 1000)

      setTimeout(function () {
        $('.demo__pics').addClass('fade-out')
        $('#formula').addClass('black')
        $('#svg-formula').addClass('black')
      }, 1500)

      setTimeout(function () {
        $('.demo__cons').addClass('fade-in')
      }, 2000)
    }
  })
}



// WEBPACK FOOTER //
// ./app/blocks/demo/demo.js